import { render, staticRenderFns } from "./CensusTable.vue?vue&type=template&id=150a38c8&scoped=true&"
import script from "./CensusTable.vue?vue&type=script&lang=js&"
export * from "./CensusTable.vue?vue&type=script&lang=js&"
import style0 from "./CensusTable.vue?vue&type=style&index=0&id=150a38c8&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150a38c8",
  null
  
)

export default component.exports